import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Video } from "lucide-react";

export default function KnowledgeBaseVideoList({ videos }) {
    const { t } = useTranslation();

    if (!videos.length) {
        return (
            <div className="text-center py-6 text-muted-foreground text-sm">
                {t("admin.support.noVideos", "No videos found")}
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center gap-2">
                <h3 className="text-sm font-semibold">{t("admin.support.youtubeVideos", "YouTube Videos")}</h3>
                <Badge variant="secondary">{videos.length}</Badge>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {videos.map((video) => (
                    <a key={video.id} href={video.url} target="_blank" rel="noopener noreferrer"
                        className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow group">
                        {video.thumbnail ? (
                            <img src={video.thumbnail} alt={video.title} className="w-full aspect-video object-cover" />
                        ) : (
                            <div className="w-full aspect-video bg-muted flex items-center justify-center">
                                <Video className="w-8 h-8 text-muted-foreground" />
                            </div>
                        )}
                        <div className="p-2">
                            <p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{video.title}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
}
